import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { NavService } from 'src/app/services/nav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-avatar-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class AvatarSelectComponent implements OnInit, OnDestroy {
  icons = [
    '../../../assets/photo/avatar1_icon.png',
    '../../../assets/photo/avatar2_icon.png',
    '../../../assets/photo/avatar3_icon.png',
    '../../../assets/photo/avatar4_icon.png',
    '../../../assets/photo/avatar5_icon.png',
    '../../../assets/photo/avatar6_icon.png'
  ];
  videos = [
    '../../../assets/video/avatar1.mp4',
    '../../../assets/video/avatar2.mp4',
    '../../../assets/video/avatar3.mp4',
    '../../../assets/video/avatar4.mp4',
    '../../../assets/video/avatar5.mp4',
    '../../../assets/video/avatar6.mp4'
  ];
  selected = 0;

  constructor(
    public auth: AuthService,
    private nav: NavService,
    private router: Router,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.nav.hide();
    });
  }

  select(i: number) {
    this.selected = i;
  }

  confirm() {
    this.router.navigate(['/avatar/confirm', {avatar: this.selected}]);
  }

  ngOnDestroy() {
    // location.reload();
  }
}
